import React from 'react'
import uuidv4 from 'uuid/v4'
import { clone } from 'lodash'
import Snackbar from 'material-ui-legacy/Snackbar'

import {
  ServiceCategoryHeader,
  ServiceCategorySubtotal
} from './QuoteFormComponents'
import LineItemInput from './LineItemInput'
import './styles/line-items-container.css'

import Resource from '../../stores/resource'
const LineItemStore = Resource('line-items')

/*
This component is used inside QuoteForm.
Props:
- category: a ServiceCategory instance.
- quoteId: the quote object id
- lineItems: array of lineItems. These will be filtered by the given ServiceCategory.
             Note that it's expected these line items already contain a key, since
             they will come from QuoteForm.
- batchOnChange: callback function, returns all contained lineItems on change
                 function(lineItems, categoryId)
*/
class CategoryLineItemsContainer extends React.PureComponent {
  constructor(props) {
    super(props)
    const { lineItems, category } = this.props

    let initialState = {
      lineItems: [],
      total: 0.0
    }

    let initialLineItems = lineItems.filter(lineItem => {
      const li = lineItem.attributes
      return Number(li.serviceCategoryId) === Number(category.id)
    })

    if (initialLineItems.length > 0) {
      // Always sort by service order
      initialState.lineItems = initialLineItems.sort(
        (a, b) => a.order - b.order
      )
      initialState.total = this._calculateTotal(initialState.lineItems)
    }

    this.state = clone(initialState)
  }

  _calculateTotal = (lineItems = this.state.lineItems) => {
    let total = 0.0
    for (let lineItem of lineItems) {
      let attributes = lineItem.attributes
      total += Number(attributes.total)
    }
    return total
  }

  _deleteLineItem = key => {
    let lineItems = this.state.lineItems.filter(
      lineItem => lineItem.key !== key
    )
    this._updateLineItems(lineItems)
  }

  _addLineItem = (serviceId, service) => {
    let newLineItem = LineItemStore.makeEntity({
      quoteId: this.props.quoteId || null,
      serviceId: serviceId,
      event: '',
      description: '',
      number: 1,
      rate: service.attributes.rate,
      rateUnit: service.attributes.rateUnit,
      adjustment: 0.0,
      total: service.attributes.rate,
      hideClientRates: false
    })
    // We absolutely must have a unique id or key
    newLineItem.key = uuidv4()
    // We're adding the selected service instance too
    newLineItem.service = service
    let lineItems = clone(this.state.lineItems)
    lineItems.push(newLineItem)
    this._updateLineItems(lineItems)
  }

  // Updates lineItems and totals at the same time
  _updateLineItems = (lineItems = this.state.lineItems) => {
    const { batchOnChange, category } = this.props
    const total = this._calculateTotal(lineItems)
    this.setState(
      {
        lineItems: lineItems,
        total: total
      },
      () => {
        if (batchOnChange) {
          batchOnChange(lineItems, category.id)
        }
      }
    )
  }

  _handleLineItemChange = (attributes, key) => {
    const lineItemIndex = this.state.lineItems.findIndex(
      lineItem => lineItem.key === key
    )
    if (lineItemIndex < 0) return
    let newLineItems = this.state.lineItems
    newLineItems[lineItemIndex].attributes = attributes
    this._updateLineItems(newLineItems)
  }

  _resetSnackbar = () => this.setState({ error: '' })

  render() {
    const { category, quoteId } = this.props
    const { lineItems, total, error } = this.state

    return (
      <section className="line-items-container">
        <ServiceCategoryHeader
          category={category}
          onSelected={this._addLineItem}
        />
        {lineItems.map(lineItem => (
          <LineItemInput
            key={lineItem.key}
            lineItem={lineItem}
            service={lineItem.service}
            quoteId={quoteId}
            deleteCallback={() => this._deleteLineItem(lineItem.key)}
            validatedOnChange={attributes =>
              this._handleLineItemChange(attributes, lineItem.key)
            }
          />
        ))}

        {lineItems.length > 0 && <ServiceCategorySubtotal total={total} />}

        <Snackbar
          open={Boolean(error)}
          message={`Coulnd't get line item service: ${error}`}
          autoHideDuration={4000}
          onRequestClose={this._resetSnackbar}
        />
      </section>
    )
  }
}

export default CategoryLineItemsContainer



// WEBPACK FOOTER //
// ./src/components/Quotes/CategoryLineItemsContainer.jsx